module.exports = __webpack_public_path__ + "img/pro-face-photo1.34be0f24.jpg";